import "./VehiclesUploadModal.scss";

import { useEffect } from "react";
import { useState } from "react";
import { useRef } from "react";

import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";

import { closeModal } from "../../../../../slices/modalSlice";

import { fetchVehiclesUpload } from "../../../../../slices/vehiclesUploadSlice";
import { fetchVehiclesDetails } from "../../../../../slices/vehiclesDetailsSlice";

import Clear from "@mui/icons-material/Clear";
import Upload from "@mui/icons-material/Upload";
import Delete from "@mui/icons-material/Delete";

import { Button } from "../../../../../common-components/Buttons/Buttons";

const VehiclesUploadModal = ({ id }) => {
    const dispatch = useDispatch();
    const token = useSelector((state) => state.auth.token);
    const loadingStatus = useSelector((state) => state.vehiclesUpload.loadingStatus);
    const error = useSelector((state) => state.vehiclesUpload.error);

    const inputRef = useRef(null);

    const [files, setFiles] = useState([]);
    const [previews, setPreviews] = useState([]);

    const handleFileSelect = (e) => {
        const selected = Array.from(e.target.files || []);
        if (!selected.length) return;

        setFiles((prev) => {
            const key = (f) => `${f.name}-${f.size}-${f.lastModified}`;
            const prevMap = new Map(prev.map((f) => [key(f), f]));
            selected.forEach((f) => prevMap.set(key(f), f));
            return Array.from(prevMap.values());
        });

        if (inputRef.current) inputRef.current.value = "";
    };

    useEffect(() => {
        const next = files.map((f) => ({
            name: f.name,
            key: `${f.name}-${f.size}-${f.lastModified}`,
            url: URL.createObjectURL(f),
        }));

        setPreviews(next);

        return () => {
            next.forEach((p) => URL.revokeObjectURL(p.url));
        };
    }, [files]);

    const removeFile = (fileKey) => {
        setFiles((prev) => prev.filter((f) => `${f.name}-${f.size}-${f.lastModified}` !== fileKey));
    };

    const clearAll = () => setFiles([]);

    const handleUpload = () => {
        if (!files.length || loadingStatus === "loading") return;

        dispatch(fetchVehiclesUpload({ token, id, files }))
            .unwrap()
            .then(() => {
                dispatch(fetchVehiclesDetails({ token, id }));
                dispatch(closeModal());
            })
            .catch(() => {});
    };

    return (
        <div className="vehicles-upload-modal">
            <div className="vehicles-upload-modal_container">
                <div className="vehicles-upload-modal_file">
                    <input
                        ref={inputRef}
                        className="vehicles-upload-modal_input"
                        type="file"
                        accept="image/*"
                        multiple
                        onChange={handleFileSelect}
                    />
                </div>
                {!!files.length && (
                    <div className="vehicles-upload-modal_files">
                        <div className="vehicles-upload-modal_filesHeader">
                            <div className="vehicles-upload-modal_filesCount">
                                Выбрано: <b>{files.length}</b>
                            </div>

                            <button
                                type="button"
                                className="vehicles-upload-modal_iconBtn"
                                onClick={clearAll}
                                aria-label="Очистить список"
                                title="Очистить"
                            >
                                <Clear />
                            </button>
                        </div>

                        <ul className="vehicles-upload-modal_filesList">
                            {files.map((f) => {
                                const k = `${f.name}-${f.size}-${f.lastModified}`;
                                return (
                                    <li key={k} className="vehicles-upload-modal_fileItem">
                                        <span className="vehicles-upload-modal_fileName" title={f.name}>
                                            {f.name}
                                        </span>

                                        <button
                                            type="button"
                                            className="vehicles-upload-modal_iconBtn vehicles-upload-modal_iconBtnDanger"
                                            onClick={() => removeFile(k)}
                                            aria-label={`Удалить ${f.name}`}
                                            title="Удалить"
                                        >
                                            <Delete />
                                        </button>
                                    </li>
                                );
                            })}
                        </ul>
                    </div>
                )}
                {!!previews.length && (
                    <div className="vehicles-upload-modal_previewsGrid">
                        {previews.map((p, i) => (
                            <button
                                key={p.key}
                                type="button"
                                className="vehicles-upload-modal_previewCard"
                                title={p.name}
                            >
                                <img
                                    className="vehicles-upload-modal_image"
                                    src={p.url}
                                    alt={`preview-${i}`}
                                    loading="lazy"
                                />
                            </button>
                        ))}
                    </div>
                )}
                <div className="vehicles-upload-modal_button">
                    <Button Icon={Upload} title="Загрузить" onClick={handleUpload} />
                </div>

                {error && <div className="vehicles-upload-modal_error">{error}</div>}
            </div>
        </div>
    );
};

export default VehiclesUploadModal;